"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.mergeArrays = function (newArray, oldArray, comparer) {
  var _a, _b;

  if (!((_a = newArray) === null || _a === void 0 ? void 0 : _a.length)) {
    return __spreadArrays(oldArray);
  }

  if (!((_b = oldArray) === null || _b === void 0 ? void 0 : _b.length)) {
    return __spreadArrays(newArray);
  }

  return oldArray.reduce(function (newResult, oldEntity) {
    var index = newResult.findIndex(function (newEntity) {
      return comparer ? comparer(newEntity, oldEntity) : newEntity['id'] === oldEntity['id'];
    });

    if (index === -1) {
      return __spreadArrays(newResult, [oldEntity]);
    }

    newResult[index] = __assign(__assign({}, oldEntity), newResult[index]);
    return newResult;
  }, newArray);
};